import React from "react";
import useWebSocket from "utils/hooks/useWebSocket";
import { WebSocketContext } from "./WebSocketContext";
import { useLocation } from "react-router-dom";

export const WebSocketProvider = ({
  children,
  user,
}: {
  children: React.ReactNode;
  user: any;
}) => {
  const protocol = window.location.protocol;
  const host = window.location.host;
  const WS_URL = `${protocol === "https:" ? "wss" : "ws"}://${host}/notification?userId=${user.id}`;
  // const WS_URL = `${protocol === "https:" ? "wss" : "ws"}://10.10.13.55:33180/notification?userId=${user.id}`;
  const { lastMessage, readyState, sendMessage } = useWebSocket(WS_URL, {
    heartbeat: true,
    heartbeatInterval: 15000,
    heartbeatMessage: JSON.stringify({
      action: "health check",
    }),
    reconnectLimit: 10,
    reconnectInterval: 5000,
  });

  const value = {
    lastMessage,
    readyState,
    sendMessage,
  };

  return (
    <WebSocketContext.Provider value={value}>
      {children}
    </WebSocketContext.Provider>
  );
};
